import axios from "axios";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { BsPersonCircle } from "react-icons/bs";
import OwlCarousel from "react-owl-carousel";

function Header() {
  let users = JSON.parse(sessionStorage.getItem("user"));

  const [homeData, sethomeData] = useState([]);

  const getAllhome = async () => {
    try {
      let res = await axios.get("https://univ.mobi/api/admin/getHeadingText");
      if (res.status === 200) {
        sethomeData(res?.data?.success);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const logOut = () => {
    sessionStorage.removeItem("user");

    window.location.reload(true);
  };

  useEffect(()=>{
    getAllhome();
  },[])
  return (
    <>
      <div className="container-fulid ">
        <div className="co-logo">
          <div className="row">
            <div className="col-md-2">
              <div className="img_he">
              <a class="name-job" href="https://univiindia.com/">   <img
                  src="/Images/un .jpg"
                  alt=""
                  style={{ width: "100px", height: "100px" }}
                /></a>
               
              </div>
            </div>
            <div className="col-md-5">
              <div className="ada">
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={10}
                  nav={false}
                  dots={false}
                    autoplay={true}
                  items={1}
                >
                  {homeData?.map((item)=>{
                    return (  <div class="item">
                    <div className="esw" style={{marginTop:"30px"}}>{item?.text1}</div>
                  </div>)
                  })}
                
                  
                </OwlCarousel>
              </div>
            </div>
            <div className="col-md-5">
              <div  className="ada-0">
              <div class="topBarRight">
                <div class="iconWrap btnLoginRegister mr-30">
                  {users ? (
                    <>
                      <div>
                        <a href="/condidate-profile">
                          <p class="btn btn-secondary w-100">
                            <BsPersonCircle
                              style={{ color: "white", marginRight: "5px" }}
                            ></BsPersonCircle>

                            <span> {users.name}</span>
                          </p>
                        </a>
                      </div>
                      <a href="/" class="ml-10" style={{ marginLeft: "10px" }}>
                        <button
                          class="btn btn-secondary w-100"
                          onClick={() => {
                            logOut();
                          }}
                        >
                          Logout
                        </button>
                      </a>
                    </>
                  ) : (
                    <div class="iconWrap btnLoginRegister mr-30">
                      <a href="/employers-login" className="btn btn-secondary">
                        <span>
                          <AiOutlineUserAdd />
                        </span>{" "}
                        For Employer
                      </a>
                      {/* <a href="/login" class="btn btn-outline-secondary">
                  Login
                </a> */}
                      <a href="/employee-login" class="ml-10">
                        <button class="btn btn-secondary w-100">
                          <span>
                            <AiOutlineUserAdd />
                          </span>{" "}
                          For Employee
                        </button>
                      </a>
                    </div>
                  )}
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Navbar expand="lg" style={{backgroundColor:" rgb(43, 183, 146)"}}>
        <Container fluid className="header-op--0">
          <Navbar.Brand href="/">
            {/* <img
              src="/Images/un .jpg
              alt="job-portals"
              style={{ width: "100%", height: "91px", marginTop: "-18px" }}
            /> */}
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="mx-auto my-2 my-lg-0"
              // style={{ maxHeight: "100px" }}
              // navbarScroll
            >
              <Nav.Link href="/">HOME</Nav.Link>
              <Nav.Link href="/about">ABOUT</Nav.Link>
              <Nav.Link href="/career-guidance">CAREER GUIDANCE</Nav.Link>
              {/* <NavDropdown title="Link" id="navbarScrollingDropdown">
              <NavDropdown.Item href="#action3">About</NavDropdown.Item>
              <NavDropdown.Item href="#action4">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action5">
                Something else here
              </NavDropdown.Item>
            </NavDropdown> */}
              <Nav.Link href="/resume-writing">RESUME WRITING</Nav.Link>
              {users ? (  <Nav.Link href="/condidate-profile">PROFILE</Nav.Link> ): ""}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
